export default {
  /**
   * Loại chart column
   */
  Column: 1,

  /**
   * Loại donut
   */
  Donut: 2,
};
